/* unplugin-vue-components disabled */import { render } from "./open_invoice_detail.vue?vue&type=template&id=601a4c14&scoped=true"
import script from "./open_invoice_detail.vue?vue&type=script&lang=js"
export * from "./open_invoice_detail.vue?vue&type=script&lang=js"

import "./open_invoice_detail.vue?vue&type=style&index=0&id=601a4c14&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601a4c14"]])

export default __exports__